import { linkifyNbfc } from "../NbfcLink";
import React from "react";
import Footer from "../Footer";
import Navbar from "../Navbar";


const InterestRatePolicy: React.FC = () => {
  const policySections = [
    {
      title: `1. ${import.meta.env.VITE_COMPANY_NBFC} (Brand Name: ${import.meta.env.VITE_COMPANY_NAME})`,
      content: `The Reserve Bank of India (RBI) through its notification DNBS.204/CGM (ASR)-2009 dated January 2, 2009, and the Master Direction DNBR. PD. 007/03.10.119/2016-17 dated September 1, 2016, directs NBFCs and their Boards to review and implement internal interest rate models that factor in the cost of funds, margin, and risk premium. ${import.meta.env.VITE_COMPANY_NBFC} ("Company"), operating under the brand "${import.meta.env.VITE_COMPANY_NAME}," complies with these guidelines and has formulated this Interest Rate Policy in line with the Fair Practices Code.`,
    },
    {
      title: "2. Disclosure",
      content: `The Company's interest rate determination process—including applicable rates and charges—is transparently disclosed on its official website and shared with customers during the loan process.`,
    },
    {
      title: "3. Interest Rate",
      list: [
        "This policy is approved by the Board of Directors and incorporates key factors: cost of funds, margin, and risk premium.",
        "Rates vary by borrower based on risk profile, credit score, and operational costs.",
        "Loan amounts range from ₹5,000 to ₹1,00,000 with tenures between 7 days and 3 months.",
        "Maximum annual rates for Q4 FY2025: 108% (Personal loans), 510.25% (Salary Advance loans).",
        "Target maximum rates for Q4 FY2026: 72% (Personal loans), 382.5% (Salary Advance loans).",
        "All loans are Fixed Rate and repaid through EMIs or Bullet repayment. Interest is payable on due date; penal interest applies for delays.",
      ],
    },
    {
      title: "4. Fees & Charges",
      list: [
        "Borrowers pay fees such as processing, credit assessment, or origination (10–15% of loan amount).",
        "Additional charges apply for EMI returns, rescheduling, or special services.",
        "Applicable taxes and cesses are levied as per law, and all revisions are prospective.",
        "Refunds or waivers may be granted solely at the Company's discretion.",
      ],
    },
    {
      title: "5. Customer Communication",
      content:
        "The final interest rate, applicable fees, and charges are clearly communicated to the borrower at loan sanction through a Sanction Letter and loan documentation. Borrowers receive a copy of the signed loan agreement after disbursal.",
    },
    {
      title: "6. Amendment",
      content:
        "This policy may be revised or updated at any time with the approval of the Board of Directors. All changes, once approved, take immediate effect.",
    },
  ];

  return (
    <div className="min-w-screen bg-[var(--background-gradient-middle)]">
      <div className="max-w-[1440px] mx-auto flex flex-col gap-12 px-4 sm:px-6 lg:px-12 py-16">
        <Navbar />

        {/* Header */}
        <div className="text-center mt-12 relative z-10 w-full mb-2 mt-12">
          <h1 className="text-4xl md:text-7xl font-[900] leading-none tracking-tighter mb-4 bg-gradient-to-r from-[var(--primary)] to-[var(--secondary-accent)] text-transparent bg-clip-text">
            Interest Rate Policy
          </h1>
          <p className="text-[var(--text-gray)] font-bold text-lg md:text-xl max-w-3xl mx-auto leading-relaxed">
            At{" "}
            <span className="font-semibold text-[var(--primary)] text-xl">
              {import.meta.env.VITE_COMPANY_NAME}
            </span>
            , we follow transparent and responsible lending practices in line
            with the Reserve Bank of India’s guidelines for NBFCs. This policy
            explains our approach to determining interest rates and lending
            charges.
          </p>
        </div>

        {/* Policy Content */}
        <div className="max-w-4xl w-full mx-auto">
          <div className="bg-white/40 backdrop-blur-3xl rounded-[32px] md:rounded-[40px] border-2 border-white/50 shadow-[20px_20px_40px_rgba(0,0,0,0.04)] p-8 md:p-12 space-y-10">
            {policySections.map((section, idx) => (
              <div key={idx} className="space-y-4">
                <h2 className="text-2xl font-[900] text-[var(--text-primary)] tracking-tight mb-2 border-b-2 border-[var(--primary)]/20 pb-2">
                  {linkifyNbfc(section.title)}
                </h2>
                {section.content && (
                  <p className="text-[var(--text-gray)] text-base whitespace-pre-line leading-relaxed font-medium">
                    {linkifyNbfc(section.content)}
                  </p>
                )}
                {section.list && (
                  <ul className="list-disc list-outside ml-6 space-y-2 text-[var(--text-gray)] text-base font-medium">
                    {section.list.map((li, i) => (
                      <li key={i} className="pl-1">{linkifyNbfc(li)}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default InterestRatePolicy;
